"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_date_object_1 = tslib_1.__importDefault(require("react-date-object"));
var createDateRange = function (_a) {
    var startDate = _a.startDate, stopDate = _a.stopDate, dateFormat = _a.dateFormat;
    var dateArray = [];
    var start = new react_date_object_1["default"](startDate);
    var end = new react_date_object_1["default"](stopDate);
    while (start <= end) {
        dateArray.push(new react_date_object_1["default"](start).format(dateFormat));
        start = new react_date_object_1["default"](start).add(1, 'days');
    }
    return dateArray;
};
exports["default"] = createDateRange;
//# sourceMappingURL=create-date-range.js.map